import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Grid from '@mui/material/Grid';
import TranslatableTextFieldInput from 'components/TranslatableTextFieldInput';

import { TranslatableTextField_text$key } from '__generated__/TranslatableTextField_text.graphql';
import { TranslatableTextField_data$key } from '__generated__/TranslatableTextField_data.graphql';

type Props = {
  name: string;
  label?: string;
  text: TranslatableTextField_text$key | null;
  data: TranslatableTextField_data$key;
};

const TranslatableTextField: FC<Props> = props => {
  const { name, label } = props;

  const text = useFragment(
    graphql`
      fragment TranslatableTextField_text on Text {
        ...TranslatableTextFieldInput_text
      }
    `,
    props.text
  );

  const data = useFragment(
    graphql`
      fragment TranslatableTextField_data on Query {
        languages {
          locale

          ...TranslatableTextFieldInput_language
        }

        ...TranslatableTextFieldInput_data
      }
    `,
    props.data
  );

  return (
    <Grid container>
      <Grid item sm={2}>
        {label}
      </Grid>
      <Grid item sm={10}>
        {data.languages.map(language => (
          <TranslatableTextFieldInput
            key={language.locale}
            name={name}
            language={language}
            text={text}
            data={data}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default TranslatableTextField;
